<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      field-name="사업장명(필수)"
      :options="[{ type: 'date', label: '점검일(필수)', value: '점검일' }]"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--    점검정보-->
    <inspection-info-list
      class="mt-5"
      title="점검정보"
      :list="form.inspectionInfo"
      @updateList="updateInspectionInfoList"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
      disaster-color="red"
    />

    <!-- 사진대지 -->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :isPrint="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="점검 현장 사진"
    />

    <!--    파일첨부-->
    <FileUploadModule
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :isPrint="isPrint"
      :readonly="board.readonly"
    />
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import InspectionInfoList from "@/components/InspectionInfoList";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import {required} from "vuelidate/lib/validators";

export default {
  components: {
    FileUploadModule,
    PhotoUploadGridModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    FieldSelectModule,
    PopupPlanProject,
    InspectionInfoList,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        '점검일' : { required },
      },
    },
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        inspectionInfo: [],
        photoList: [],
        fileList: [],
        disasters: '',
      },
    };
  },
  methods: {
    updateInspectionInfoList(list) {
      this.form.inspectionInfo = list;

      this.form.disasters = ""
      for (const risk of this.form.inspectionInfo) {
        this.form.disasters += `${risk.disaster} `
      }
    },

    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo['점검일'].required) {
          alert("점검일을 반드시 입력해야 합니다");
        }

        return false;
      } else {
        // 유효성 검사가 성공한 경우
        return true;
      }
    },
  },
};
</script>

<style scoped></style>
